
const selectCounterValue = state => state.counter.value;

export default selectCounterValue;